import $http from '../../axios-intance';
import {Notification} from 'element-ui';

function notifyError(error) {
    Notification.error({
        title: 'Error!',
        message: error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message,
        type: 'error',
        duration: 1500,
        customClass: 'notification-box',
    });
}

// Roles para el selector (mismo endpoint del módulo de roles: GET /api/roles).
export async function fetchRoles({commit}) {
    await $http.get('/api/roles')
        .then((response) => commit('setRoles', response.data.data))
        .catch(notifyError);
}

// Catálogo completo con check = false: las secciones se ven siempre, incluso antes de elegir un rol.
export async function fetchCatalog({commit}) {
    commit('setLoading', true);

    await $http.get('/api/role-dashboard-permissions')
        .then((response) => commit('setPermissions', response.data.data))
        .catch(notifyError)
        .finally(() => commit('setLoading', false));
}

// Selecciona un rol y carga sus permisos. Sin rol vuelve al catálogo vacío.
export async function selectRole({commit, dispatch}, roleId) {
    commit('setSelectedRoleId', roleId);

    if (!roleId) {
        await dispatch('fetchCatalog');
        return;
    }

    commit('setLoading', true);

    await $http.get('/api/role-dashboard-permissions', {params: {role_id: roleId}})
        .then((response) => commit('setPermissions', response.data.data))
        .catch(notifyError)
        .finally(() => commit('setLoading', false));
}

// Guarda (reemplaza) los permisos del rol seleccionado.
export async function savePermissions({commit, state}) {
    if (!state.selectedRoleId) {
        notifyError({message: 'Debe seleccionar un rol'});
        return;
    }

    commit('setSaving', true);

    const payload = {
        role_id: state.selectedRoleId,
        permissions: state.permissions.map(p => ({name: p.name, check: !!p.check}))
    };

    await $http.put('/api/role-dashboard-permissions', payload)
        .then((response) => {
            commit('setPermissions', response.data.data);
            Notification.success({
                title: 'Exito!',
                message: 'Los permisos del dashboard se han guardado correctamente',
                type: 'success',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
        .catch(notifyError)
        .finally(() => commit('setSaving', false));
}
